module.exports = __webpack_public_path__ + "img/website.dca3e76f.png";